import React, { useState } from "react";
import style from "./ChangeRequest.module.scss";
import Warning from "../../assets/svg/Warning.svg";
import Chevron from "../../assets/svg/Chevron.svg";
import ChevronUp from "../../assets/svg/ChevronUp.svg";
import {
  getRiskSeverityStatus,
  getRiskSeverityColorClass,
  getRiskType,
  getRiskStatus,
  renderHealthStatus,
  getLabelByType,
} from "../../helpers/utils.js";
import SafeHtml from "../../components/safeHtml/SafeHtml.jsx";
import { dateOnlyFormatted } from "../../utils/systemSettings.js";
import { CircleCheck, TriangleAlert } from "lucide-react";
import { Tooltip } from "react-bootstrap";
import HoverCard from "../../components/hoverCard/HoverCard.jsx";
import { Avatar } from "@fluentui/react-components";

const RiskItem = ({ item }) => {
  const [show, setShow] = useState(false);
  const settings = JSON.parse(localStorage.getItem("settings"));

  const handleToggle = () => {
    setShow(!show);
  };


  return (
    <div className={`${style.mainWrapper} mb-3`}>
      <div className={`${style.headerWrapper} w-100`} onClick={handleToggle}>
        <div className="d-flex w-50">
          <div
            className={`${style.inlinePills} d-flex justify-content-between`}
          >
            {item.dateResolved && <div className="d-flex align-items-center"> <CircleCheck size={16} color="#5aa55a" /></div>}
            {!item.dateResolved && item.status !== 5 && <div className="d-flex align-items-center"> <TriangleAlert size={16} color="#d1424f" /></div>}
            <div className="flex justify-center mx-1">
              {renderHealthStatus({ period: `Risk Trending Status - ${getLabelByType("riskTrending", item.trendingStatus)}`, status: item.trendingStatus, isForecast: true }, item.Id)}
            </div>
            <p className="text-md-600 ms-2 mb-0">{item.name}</p>
          </div>
        </div>
        <div className={`${style.gapsBetweeen} d-flex`}>
          <div className={`${style.riskPills}`}>
            <div className={`${style.riskPill}`}>
              <div className={`${style.riskPillContent}`} >
                <label className="text-xsm-600 grey10Color mb-1">Severity</label>
                <span className={`pill ${style.riskPillOverride} ${getRiskSeverityColorClass(item.severity)}`}>{getRiskSeverityStatus(item.severity)}</span>
              </div>
            </div>
            <div className={`${style.riskPill}`}>
              <div className={`${style.riskPillContent}`} >
                <label className="text-xsm-600 grey10Color mb-1">Type</label>
                <span className={`pill Completed ${style.riskPillOverride}`}>{getRiskType(item.type)}</span>
              </div>
            </div>
            <div className={`${style.riskPill}`}>
              <div className={`${style.riskPillContent}`} >
                <label className="text-xsm-600 grey10Color mb-1">Status</label>
                <span className={`pill ${item.status === 0 || item.status === 1
                  ? "OnTrack"
                  : item.status === 2
                    ? "OffTrack"
                    : item.status === 3 || item.status === 4
                      ? "AtRisk"
                      : "Completed"
                  }`}>{getRiskStatus(item.status)}</span>
              </div>
            </div>
          </div>
          <img
            className={`${style.arrowleftGap}`}
            src={show ? ChevronUp : Chevron}
            alt=""
          />
        </div>
      </div>

      {show && (
        <div className={style.riskItemWrapper}>

          <div className={style.riskItemMeta}>
            <h6 className={style.riskItemTitle}>Prime:</h6>
            {
              item.owner && (
                <>
                  <HoverCard
                    HoverCardTrigger={
                      <div>
                        <Avatar
                          size={20}
                          color="colorful"
                          name={item?.owner.name}
                          image={{ src: item?.owner.image }}
                        />
                      </div>
                    }
                    AvatarId={item?.owner?.id}
                    AvatarName={item?.owner?.name}
                    AvatarImage={item?.owner?.image}
                    AvatarDesignation={item?.owner?.title}
                    AvatarEmail={item?.owner?.email}
                    AvatarPhone={item?.owner?.phoneNumber}
                    AvatarIsExternal={item?.owner?.isExternal}
                    CanSendMessage={true}
                  />
                  <p className="ms-1">{item.owner.name}</p>
                </>
              )
            }

          </div>
          <div className={style.riskItemBlockDates}>
            <div className={style.riskItemMeta}>
              <h6 className={style.riskItemTitle}>Date Identified:</h6>{dateOnlyFormatted(settings, item.dateIdentified)}
            </div>
            <div className={style.riskItemMeta}>
              <h6 className={style.riskItemTitle}>Date Impact:</h6>{dateOnlyFormatted(settings, item.dateImpact)}
            </div>
            <div className={style.riskItemMeta}>
              <h6 className={style.riskItemTitle}>Date Resolved:</h6> {dateOnlyFormatted(settings, item.dateResolved)}
            </div>
          </div>

          {item.description && (
            <div className={style.riskItemBlock}>
              <h6 className={style.riskItemTitle}>Description</h6>
              <p className={style.riskItemDescription}>
                <SafeHtml html={item.description} />
              </p>
            </div>
          )}

          {item.mitigationPlan && (
            <div className={style.riskItemBlock}>
              <h6 className={style.riskItemTitle}>Mitigation Plan</h6>
              <p className={style.riskItemDescription}>
                <SafeHtml html={item.mitigationPlan} />
              </p>
            </div>
          )}
        </div>
      )}
    </div>

  );
};

export default RiskItem;
